import Widget from '@/plugins/dashboard/classes/BaseWidget'

const widgets = (ctx => {
  let widgets = {}

  ctx
    .keys()
    .map(ctx)
    .map(m => m.default)
    .filter(f => typeof f !== 'undefined' && f.prototype instanceof Widget)
    .map(w => { widgets[w.name] = w })

  return widgets
})(require.context('./', true))

export default widgets
